import React, { useState } from 'react'
import { Button, Dialog } from '@material-ui/core'
import DialogView from '../../Dialogos/DialogView'

function ReporteCamiones (props) {
  const { contenido, buttonName } = props
  const [open, setOpen] = useState(false)

  const handleOpen = () => { setOpen(true) }
  const handleClose = () => { setOpen(false) }

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth='lg'
      >
        <DialogView
          cancelCallback={handleClose}
          title=''
          content={
            <div style={{ padding: '2%', textAlign: 'center', minWidth: '270px' }}>
              {contenido}
            </div>
          }
        />
      </Dialog>

      <Button
        className='btn-reporte-egreso-qr'
        style={{ margin: '2px' }}
        color='primary'
        onClick={handleOpen}
        type='button'
        size='small'
        variant='contained'
      > {buttonName}
      </Button>
    </>
  )
}

export default ReporteCamiones
